/* eslint-disable import/prefer-default-export */
export const DefaultDebouceDelay = 500;
